/**
 * Section access helpers (OWZ-18).
 *
 * Centralises the rule used by AdminLayout / AdminDashboard / AdminDashboardHome
 * for deciding whether the current admin can see a given section. Three things
 * compose, in this order of precedence:
 *
 *   1. Role gate (new in OWZ-18). If the section defines `requiresRole`, the
 *      admin's `role` must be in that list — even protected admins are gated
 *      by the role check. This is what restricts History Reviews to
 *      instructors / owners.
 *
 *   2. Protected-admin bypass. `is_protected` users skip the
 *      allowed_sections check and see everything they're role-eligible for.
 *
 *   3. allowed_sections opt-in for non-protected admins.
 */
import { getSectionById } from './adminRoutes';

export const getAdminUser = () => {
  try {
    return JSON.parse(localStorage.getItem('adminUser') || '{}');
  } catch {
    return {};
  }
};

export const canAccessSection = (sectionId, adminUser = getAdminUser()) => {
  const section = getSectionById(sectionId);
  const role = adminUser?.role || null;

  if (section?.requiresRole && !section.requiresRole.includes(role)) {
    return false;
  }

  if (adminUser?.is_protected) return true;
  const allowedSections = adminUser?.allowed_sections || [];
  return allowedSections.includes(sectionId);
};
